import { render } from "./AGCAREList.vue?vue&type=template&id=8d8d5aac&scoped=true"
import script from "./AGCAREList.vue?vue&type=script&lang=js"
export * from "./AGCAREList.vue?vue&type=script&lang=js"

import "./AGCAREList.vue?vue&type=style&index=0&id=8d8d5aac&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d8d5aac"]])

export default __exports__